import React from 'react';
import { Divider, Form, message, Row, Spin } from 'antd';
import { InputComponent } from '../shared/FormComponent/InputComponent';
import { prepareInput,
} from '../../utils/InputFieldCongifurations';
import { connect } from 'react-redux';
import { googleLogin } from './authActionCreators';
import { ComponentText } from '../shared/ComponentText';
import Space from '../shared/Spcae';
import { ComponentButton } from '../shared/ComponentButton';
import { fonts } from '../../utils/fonts';
import { TopBar } from './Topbar';
import utils from '../../utils/utils';

class SocialSignUpForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      organization_name: prepareInput('organization_name', 'Organization Name', true, 'Dropbox', '', 'Enter organization name', '', '' ),
    };
  }

  componentDidMount() {
    if (utils.isLoggedIn(this.props.loginData)) {
      this.props.history.push('/dashboard');
    }
  }
  componentDidUpdate (prevProps, prevState, snapshot) {
    const { data, googleMessage, isFailed } = this.props;


    if (googleMessage !== null && prevProps.googleMessage !== googleMessage && isFailed === true) {
      this.error(utils.getErrorText(googleMessage));
    }

    if(data && data !== prevProps.data){
      this.success("Logged In");
      this.props.history.push('/dashboard');
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const query = new URLSearchParams(this.props.location.search);
        const token = query.get('access_token');
        const provider = query.get('provider');

        // console.log({
        //   access_token: token,
        //   provider: provider,
        //   organization_name: values.organization_name
        // });

        this.props.googleLogin({
          access_token: token,
          provider: provider,
          organization_name: values.organization_name
        });

      }
    });
  };

  success = text => {
    message.success(text);
  };

  error = text => {
    if (text === null) return;
    message.error(text);
  };

  render() {
    const { isFetching,} = this.props;

    return (
      <Spin spinning={!!isFetching}>
        <TopBar/>
        <div style={{height:window.innerHeight - 71, backgroundColor:"#fafafa"}}>
          <Row justify={"center"} type={"flex"}>
            <div className={"login-container"}>
              <ComponentText
                text="Sign Up"
                size="23"
                color="var(--dark-grey-blue-two)"
                font={fonts.SFProDisplayRegular}
              />
              <Space height={12}/>

              <Divider />

              <div style={{paddingLeft: 60, paddingRight:60}}>
                <Form onSubmit={this.handleSubmit} layout="vertical">

                  <InputComponent
                    form={this.props.form}
                    layout={formItemLayout}
                    values={this.state.organization_name}
                  />


                  <Form.Item className="no-bottom-margin">
                    <ComponentButton
                      htmlType="submit"
                      name="Continue"
                      text="Continue"
                      css="dark-sky-blue eina-semibold-white-15"
                      styl={{height: '42px' }}
                      stylText={{ fontFamily: 'SFProDisplay-Medium' }}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>
          </Row>
        </div>
      </Spin>
    );
  }
}

const SocialSignUp = Form.create({ name: 'social-sign-up' })(SocialSignUpForm);

const mapActionToProps = {
  googleLogin,
};


const mapStateToProps = state => {
  const {signUpGoogleRemoteData, loginRemoteData} = state;

  console.log(signUpGoogleRemoteData);
  console.log(loginRemoteData);
  return {
    data: utils.getItem(signUpGoogleRemoteData),
    isFetching: utils.getIsFetching(signUpGoogleRemoteData),
    isFailed: utils.getIsFailed(signUpGoogleRemoteData),
    googleMessage: utils.getMessage(signUpGoogleRemoteData),

    loginData: utils.getItem(loginRemoteData),
  };
};
export default connect(mapStateToProps, mapActionToProps)(SocialSignUp);

const formItemLayout = {
  labelCol: {
    xs: { span: 2 },
    sm: { span: 2 },
  },
  wrapperCol: {
    xs: { span: 2 },
    sm: { span: 2 },
  },
};
